/**
 * Hook API — Fire-and-forget trace submission
 */

import { getApiKey, loadConfig } from '../../lib/config.js';
import type { TracePayload } from './state.js';

const API_TIMEOUT_MS = 5000;

export async function sendBatchTrace(traces: TracePayload[]): Promise<void> {
  const apiKey = getApiKey();
  if (!apiKey) {
    process.stderr.write(
      '[mutagent hooks] Warning: Not authenticated. Run: mutagent auth login\n'
    );
    return;
  }

  const config = loadConfig();
  const endpoint = config.endpoint ?? 'http://localhost:3003';

  const headers: Record<string, string> = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
  };
  if (config.defaultWorkspace) {
    headers['x-workspace-id'] = config.defaultWorkspace;
  }
  if (config.defaultOrganization) {
    headers['x-organization-id'] = config.defaultOrganization;
  }

  const controller = new AbortController();
  const timeout = setTimeout(() => { controller.abort(); }, API_TIMEOUT_MS);

  try {
    const response = await fetch(`${endpoint}/api/traces/batch`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ traces }),
      signal: controller.signal,
    });

    if (!response.ok) {
      const body = await response.text().catch(() => '');
      process.stderr.write(
        `[mutagent hooks] Warning: API returned ${String(response.status)}: ${body.slice(0, 200)}\n`
      );
    }
  } finally {
    clearTimeout(timeout);
  }
}
